import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMiscStore = defineStore('misc', () => {
  const ossURL = ref<string | null>(null)
  const AIToolconfig = ref<any[]>([])
  const client_id = ref<string | null>(null)
  const templateName = ref<string | null>(null)

  const setOssURL = (url: string | null) => {
    ossURL.value = url
  }
  const setClientID = (id: string | null) => {
    client_id.value = id
  }
  const setTemplateName = (name: string | null) => {
    templateName.value = name
  }
  const getTemplateName = () => templateName.value
  const getOssURL = () => ossURL.value
  const getClientID = () => client_id.value
  const setAIToolconfig = (list: any[]) => {
    AIToolconfig.value = Array.isArray(list) ? list : []
  }
  const getAIToolconfig = (id?: number | string) => {
    if (id === undefined || id === null) return AIToolconfig.value
    const found = AIToolconfig.value.find((item: any) => String(item?.id) === String(id))
    return found || false
  }

  return {
    ossURL,
    setOssURL,
    templateName,
    setTemplateName,
    getTemplateName,
    getOssURL,
    AIToolconfig,
    setAIToolconfig,
    getAIToolconfig,
    client_id,
    setClientID,
    getClientID
  }
})
